import type { CookieDefinition } from "./cookies";

export function readCookie(
  cookieHeader: string | null | undefined,
  cookie: CookieDefinition,
): string | null {
  if (!cookieHeader) return null;
  const match = cookieHeader
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${cookie.name}=`));
  if (!match) return null;
  try {
    return decodeURIComponent(match.slice(cookie.name.length + 1));
  } catch {
    return null;
  }
}
